module.exports = __webpack_public_path__ + "static/media/partially-accessible.d15ad012.svg";